import { Injectable } from '@angular/core';
import { Location } from '@obo-dashboard/models/projectManagement.models';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class AddressService {
    public coordinatesSubject = new Subject<{ lat: number; lng: number }>();
    public locationSubject: BehaviorSubject<Location>;

    public initLocationSubject(location: Location) {
        if (!this.locationSubject) this.locationSubject = new BehaviorSubject(location);
        else this.locationSubject.next(location);
    }

    public static convertPlaceResultToLocation(placeResult: google.maps.places.Place): Location {
        let location = new Location();
        location.latitude = placeResult.location.lat();
        location.longitude = placeResult.location.lng();
        location.address = placeResult.formattedAddress;

        return location;
    }
}
